import React from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  Divider,
} from "@material-ui/core";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { showMessage } from "../../../../../state/app/appActions";
import {
  confirmarColetaTardia,
  naoColetado,
} from "../../../../../state/order/actions";
import OrderToast from "../OrderToast/OrderToast";
import useStyles from "./AnalyzeCollectionDialog.styles";

const OPTIONS = {
  CONFIRM_COLLECTION: "confirm-collection",
  NOT_COLLECTED: "not-collected",
};

export default function AnalyzeCollectionDialog({
  open,
  onClose,
  onConfirm,
  pedido,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [option, setOption] = React.useState("");
  const [saving, setSaving] = React.useState(false);

  const handleClose = () => {
    setOption("");
    onClose && onClose();
  };

  const handleConfirm = async () => {
    if (!pedido || saving) return;

    const { origem, codigoExterno } = pedido;
    const isConfirm = option === OPTIONS.CONFIRM_COLLECTION;

    setSaving(true);
    const response = await dispatch(
      isConfirm
        ? confirmarColetaTardia(origem, codigoExterno)
        : naoColetado(origem, codigoExterno)
    );
    setSaving(false);

    if (!response || response.status !== 200) {
      return;
    }

    dispatch(
      showMessage(
        isConfirm
          ? 'Pedido movido para "Histórico".'
          : 'Pedido movido para aba "Em análise".',
        isConfirm ? "success" : "info",
        {
          anchorOrigin: { vertical: "top", horizontal: "right" },
          content: (key, message) => (
            <OrderToast
              id={key}
              message={message}
              variant={isConfirm ? "success" : "info"}
            />
          ),
        }
      )
    );

    onConfirm && onConfirm(option);
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      PaperProps={{ className: classes.paper }}
    >
      <div className={classes.content}>
        <Typography className={classes.title}>
          Analisar coleta do pedido
        </Typography>

        <RadioGroup
          className={classes.options}
          value={option}
          onChange={(e) => setOption(e.target.value)}
        >
          <FormControlLabel
            className={classes.option}
            value={OPTIONS.CONFIRM_COLLECTION}
            control={<Radio color="primary" />}
            label={
              <div className={classes.optionText}>
                <Typography className={classes.optionTitle}>
                  Confirmar coleta
                </Typography>
                <Typography className={classes.optionDescription}>
                  Marque essa opção se o entregador já retirou este pedido na
                  loja.
                </Typography>
              </div>
            }
          />
          <FormControlLabel
            className={classes.option}
            value={OPTIONS.NOT_COLLECTED}
            control={<Radio color="primary" />}
            label={
              <div className={classes.optionText}>
                <Typography className={classes.optionTitle}>
                  Pedido não coletado
                </Typography>
                <Typography className={classes.optionDescription}>
                  Marque essa opção se o pedido não foi coletado e está na loja.
                  <br />
                  <span className={classes.bold}>
                    Entre em contato com o SAL para analisarem o pedido
                  </span>
                  .
                </Typography>
              </div>
            }
          />
        </RadioGroup>

        <Divider className={classes.divider} />

        <div className={classes.salBox}>
          <WhatsAppIcon className={classes.salIcon} />
          <div className={classes.salText}>
            <Typography component="p" className={classes.salBold}>
              SAL - Serviço de Atendimento à Loja
              <br />
              WhatsApp: (11) 99149-2204
            </Typography>
            <Typography component="p" className={classes.salLine}>
              Segunda a Sexta, das 09h às 21h.
            </Typography>
            <Typography component="p" className={classes.salLine}>
              Sábado, das 09h às 19h.
            </Typography>
          </div>
        </div>

        <Divider className={classes.divider} />

        <div className={classes.footer}>
          <Button
            variant="outlined"
            color="primary"
            disabled={saving}
            onClick={handleClose}
          >
            Fechar
          </Button>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            disabled={!option || saving}
            onClick={handleConfirm}
          >
            Confirmar
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
